const STEPS = [
  {
    n: "01",
    title: "Diagnostic",
    body:
      "Two-week structured intake. We audit data assets, decision rights, and the metrics actually used in the room.",
  },
  {
    n: "02",
    title: "Architecture",
    body:
      "We design the warehouse, semantic layer, and contract surface — vendor-neutral, audit-ready, and reversible.",
  },
  {
    n: "03",
    title: "Build & Operate",
    body:
      "Squad-based delivery: data engineer, ML engineer, and analytics lead. Production from week six, not week twenty.",
  },
  {
    n: "04",
    title: "Transfer",
    body:
      "Full runbook, training, and a 90-day shadow. Your team owns the surface; we stay on for retainer if useful.",
  },
];

export default function Methodology() {
  return (
    <section id="method" data-testid="method-section" className="border-b border-neutral-200 bg-white">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8 py-20 md:py-32 grid grid-cols-12 gap-8">
        <div className="col-span-12 lg:col-span-4">
          <span className="font-mono-tech text-xs tracking-[0.2em] uppercase text-neutral-500">
            [06] Methodology
          </span>
          <h2 className="mt-4 font-display text-4xl md:text-5xl lg:text-6xl font-black tracking-tighter leading-[0.95]">
            One protocol.
            <br />
            <span className="text-neutral-400">Public or private.</span>
          </h2>
          <p className="mt-6 text-neutral-700 leading-relaxed max-w-md">
            A repeatable engagement model used across federal programs and Fortune 500 boardrooms.
            Every artefact is reversible, every metric is testable, every model is documented to
            audit standard.
          </p>
        </div>

        <div className="col-span-12 lg:col-span-8 border-t border-l border-neutral-200">
          {STEPS.map((s) => (
            <div
              key={s.n}
              data-testid={`step-${s.n}`}
              className="grid grid-cols-12 border-r border-b border-neutral-200 hover:bg-neutral-50 transition-colors"
            >
              <div className="col-span-3 md:col-span-2 p-6 md:p-8 border-r border-neutral-200 flex items-start">
                <span className="font-mono-tech text-xs tracking-[0.2em] uppercase text-[#002FA7]">
                  {s.n}
                </span>
              </div>
              <div className="col-span-9 md:col-span-10 p-6 md:p-8">
                <h3 className="font-display text-2xl md:text-3xl font-bold tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-neutral-700 leading-relaxed max-w-xl">{s.body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
